import { forwardRef } from 'react';

import { useAccount } from 'wagmi';

import ChainIcon from '@/components/ChainIcon';
import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';
import { truncateMidAddressInputValue } from '@/utils/truncateAddress';

export const ConnectedEvmWalletButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    const account = useAccount();
    const resultAddress = truncateMidAddressInputValue(account.address!);

    return (
      <Button
        ref={ref}
        size="sm"
        variant="secondary"
        className={cn('font-roboto rounded-xl font-bold', className)}
        {...props}
      >
        {children || (
          <div className="flex items-center gap-1 text-sm sm:gap-2">
            <ChainIcon src={(account.chain?.custom?.icon as string) || ''} />
            <div className="hidden sm:block">{resultAddress}</div>
          </div>
        )}
      </Button>
    );
  }
);

ConnectedEvmWalletButton.displayName = 'ConnectedEvmWalletButton';
